import type { InsertDepartmentTypeWithOptionalGroupIdMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

const mapTrpcResponseToGraphQL = (
  id: string
): InsertDepartmentTypeWithOptionalGroupIdMutation => {
  return {
    insert_department_type_one: {
      __typename: 'department_type',
      DepartmentTypeId: id,
    },
  };
};

export const useInsertDepartmentTypeWithOptionalGroupIdTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.department.insertTypeWithGroupId.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.department.allTypes.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.department.departmentTypeGroups.queryKey(),
        });
      },
    }),
  });

  return {
    insertDepartmentTypeWithOptionalGroupId: async (variables: {
      Name: string;
      Description?: string | null;
      DepartmentTypeGroupId?: string | null;
    }): Promise<InsertDepartmentTypeWithOptionalGroupIdMutation> => {
      const result = await mutation.mutateAsync({
        Name: variables.Name,
        Description: variables.Description,
        DepartmentTypeGroupId: variables.DepartmentTypeGroupId,
      });

      return mapTrpcResponseToGraphQL(result.Id);
    },
    loading: mutation.isPending,
    error: mutation.error,
    data: mutation.data
      ? mapTrpcResponseToGraphQL(mutation.data.Id)
      : undefined,
  };
};
